import React, { FC } from 'react'
import { InformationCircleIcon } from '@heroicons/react/solid'
import { Button } from '../../../System'
import { StyledSidebarPrompt } from '.'
import ROUTES from '../../../utils/routes'

const SidebarPrompt: FC = () => {
  return (
    <StyledSidebarPrompt className="sidebar-prompt">
      <div className="prompt">
        <div className="tip">
          <InformationCircleIcon />
          <span>
            Get access to 150+ fill-in-the-blank caption templates and a gallery of 4,500+ lifestyle
            photos so you can start posting in less than 5 minutes a day!
          </span>
        </div>
        <a href={ROUTES.external.pricingUrl} target="_blank" rel="noopener noreferrer">
          <Button>LEARN MORE</Button>
        </a>
      </div>
    </StyledSidebarPrompt>
  )
}

export default SidebarPrompt
